import { makeAutoObservable } from "mobx";

class MaintenanceStore {
  enabled = false;

  constructor() {
    makeAutoObservable(this);
  }

  setEnabled(value: boolean) {
    this.enabled = value;
  }
}

export const maintenanceStore = new MaintenanceStore();
